export default __webpack_public_path__ + "static/media/freetaps.a949845a.png";